Handlebars.registerPartial('partials/common/user-picker/list-arrangergroups', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"data-table-lazyload full-height\">\n    <table class=\"data-table table-no-border table-striped\" data-control=\"table\">\n        <tbody>\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"partials/common/user-picker/list-arrangergroups-row"),depth0,{"name":"partials/common/user-picker/list-arrangergroups-row","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        </tbody>\n    </table>\n</div>";
},"usePartial":true,"useData":true}));